<p>
  filter-numeric works!
</p>
